<!-- 登录 -->
<template>
  <div style="height: 100%; background: #253746;">
    <Header></Header>
    <div class="login tc">
      <p class="fb tc f20 pt30 mb10"><span style="color: #c90a5b;">Red</span><span style="color: #000">Wealth</span></p>
      <el-input v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user" type="text"></el-input>
      <el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-unlock" type="password" show-password></el-input>
      <div class='tl' style='width: 440px; margin: 0 auto;'>
        <el-checkbox v-model='check'></el-checkbox>
        <span>我已阅读并同意</span><span class='color-primary cursor' @click='openTerm'>《使用条款》</span>
      </div>
      <div style='width: 440px;margin: 0 auto' class="tr">没有账号?开始<span class="color-primary cursor" @click='toSignup'>注册</span></div>
      <el-button class="co-f mt20" type="primary" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      account: '',
      password: '',
      check: false
    }
  },
  components: { Header },
  mounted () {
    // 禁止回退
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    })
    console.log(document.referrer)
    const paramStr = atob(this.$route.query.param)
    this.account = paramStr.split(':')[0]
    this.password = atob(paramStr.split(':')[1])

    // if (this.account !== "" && this.password !== ""){
    //   this.check = true
    //   this.login()
    // }

    // todo 根据referrer 判断是否解析参数
  },
  created () {
    var _this = this;
    document.addEventListener("keydown", _this.watchEnter);
  },
  methods: {
    //监听回车按钮事件
    watchEnter (e) {
      var keyNum = window.event ? e.keyCode : e.which; //获取被按下的键值
      //判断如果用户按下了回车键（keycody=13）
      if (keyNum == 13) {
        this.login()
      }
    },
    openTerm () {
      window.open('/static/term.html', '_blank')
    },
    toSignup () {
      this.$router.push({ name: 'SignUp' })
    },
    login () {
      // this.$router.push({name: 'KnowYou'})
      const url = this.$api.Login
      const me_url = '/api/users/me'
      // // {gq1 123456}
      if (this.account === '') {
        this.$message({ type: 'error', message: '请输入账号！' })
        return
      }
      if (this.password === '') {
        this.$message({ type: 'error', message: '请输入密码！' })
        return
      }
      if (!this.check) {
        this.$message({ type: 'error', message: '请先点击同意条款！' })
        return
      }
      const params = {
        "username": this.account,
        "password": this.password
      }
      let data = new FormData()
      data.append('username', this.account)
      data.append('password', this.password)
      this.$http.post(url, data, {}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          localStorage.setItem('username', this.account)
          localStorage.setItem('token', res.data.access_token)
          this.$store.dispatch('setToken', res.data.access_token)
          this.$http.get(me_url, {}, {Authorization: `Bearer ${res.data.access_token}`}, window._env_.api_url, res => {
            localStorage.setItem('sales_flag', res.data.is_sales)
            this.$store.dispatch('setSalesFlag', res.data.is_sales)
            if (res.data.is_sales) {
              this.$router.push({ name: 'ClientManage' })
            } else {
              this.$router.push({ name: 'KnowYou' })
            }
          })
        }
      })
    }
  },
  destroyed () {
    //移除监听回车按键
    var _this = this;
    document.removeEventListener("keydown", _this.watchEnter);
  }
}
</script>

<style scoped>
.login {
  width: 530px;
  height: 355px;
  border-radius: 10px;
  background: #fff;
  margin: 120px auto;
}

.el-input {
  width: 440px;
  height: 38px;
  line-height: 38px;
  margin: 20px auto;
}

.el-button {
  width: 440px;
  background: #e90a5b;
  border-color: #e90a5b;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue